import { render, staticRenderFns } from "./DetailBlog.vue?vue&type=template&id=5ecdf8d4&"
import script from "./DetailBlog.vue?vue&type=script&lang=js&"
export * from "./DetailBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports